import {
  type CatalogItemTagIcon,
  type CatalogItemTagVariant,
  CatalogItemTagVariants,
} from '../../value-objects/CatalogItemTag'
import { CatalogItemTagGlyph } from '../CatalogItemTagGlyph'
import { CatalogItemTagIconStyled } from './styles/CatalogItemTagIconStyled'
import { CatalogItemTagLabelStyled } from './styles/CatalogItemTagLabelStyled'
import { CatalogItemTagLayoutStyled } from './styles/CatalogItemTagLayoutStyled'

const TAG_ICON_SIZE = 12

export interface ICatalogItemTagProps {
  icon: CatalogItemTagIcon
  text: string
  variant?: CatalogItemTagVariant
}

export const CatalogItemTag = ({
  icon,
  text,
  variant = CatalogItemTagVariants.DEFAULT,
}: ICatalogItemTagProps) => (
  <CatalogItemTagLayoutStyled $variant={variant}>
    <CatalogItemTagIconStyled $size={TAG_ICON_SIZE} aria-hidden>
      <CatalogItemTagGlyph icon={icon} size={TAG_ICON_SIZE} />
    </CatalogItemTagIconStyled>
    <CatalogItemTagLabelStyled>{text}</CatalogItemTagLabelStyled>
  </CatalogItemTagLayoutStyled>
)
